<template>
  <div>
    <app-header :title="title" />
    <img style="width: 100%" src="./goods-merchandise1.jpg" alt="" />
    <img style="width: 100%" src="./goods-merchandise2.jpg" alt="" />

    <!-- <p v-show="!show" style="position: absolute; top: 0; left: 0; text-align: center; width: 100%; padding-top: 0.2rem">
      {{ text }}
    </p> -->
    <!-- <pdf v-show="show" v-for="i in numPages" :key="i" :src="src" :page="i" class="pdf" :style="style"></pdf> -->
    <!-- <div v-show="show" @click="down" class="down"></div>
    <div v-show="show" @click="add" class="add">+</div>
    <div v-show="show" @click="reduce" class="reduce">-</div>-->
  </div>
</template>

<script>
// import pdf from 'vue-pdf-signature'
// import CMapReaderFactory from 'vue-pdf-signature/src/CMapReaderFactory'
import Body from '@/mixins/body'
const componentName = 'goods-vip-forever-protocol2022'

export default {
  componentName,
  mixins: [Body],
  components: {
    // pdf
  },
  name: componentName,
  data() {
    return {
      title: '2024友邻少年-美国游学之旅购买协议书',
      numPages: '',
      src: '',
      pdfUrl: '',
      show: false,
      rotate: 0,
      style: 'width:100%',
      widt: 100,
      text: 'PDF加载中，请耐心等待...'
    }
  },
  methods: {
    loadPdf(url) {
      this.src = pdf.createLoadingTask({
        url: url,
        cMapPacked: true,
        CMapReaderFactory
      })
      this.src.promise
        .then(pdf => {
          this.show = true
          this.numPages = pdf.numPages // 这里拿到当前pdf总页数
        })
        .catch(err => {
          console.log(err)
          this.text = '暂未查到PDF，请稍后重试...'
        })
    },
    add() {
      // 放大
      this.widt += 20
      this.style = `width:${this.widt}%`
    },
    reduce() {
      // 缩小
      this.widt -= 20
      this.style = `width:${this.widt}%`
    },
    down() {
      var e = document.createElement('a')
      e.style.display = 'none'
      e.href = ''.concat(`${this.pdfUrl}`) + '&response-content-type=application/pdf&报告.pdf'
      // e.setAttribute("download", "t.pdf")
      e.setAttribute('target', '_blank')
      document.body.appendChild(e)
      console.log(e)
      e.click()
      document.body.removeChild(e)
    }
  },
  mounted() {
    this.pdfUrl = `https://mv-cdn1.ylyk.com/protocol/YLYK_study_tour_purchase_agreement_20240624.pdf`
    // this.loadPdf(this.pdfUrl)
  }
}
</script>

<style scoped>
.down {
  width: 0.3rem;
  height: 0.3rem;
  position: fixed;
  right: 0.1rem;
  bottom: 1rem;
  /* background-image: url(./download2.png); */
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.add {
  width: 0.3rem;
  height: 0.3rem;
  position: fixed;
  right: 0.1rem;
  bottom: 1.8rem;
  /* background-image: url(./add.png); */
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.reduce {
  width: 0.3rem;
  height: 0.3rem;
  position: fixed;
  right: 0.1rem;
  bottom: 1.4rem;
  /* background-image: url(./reduce.png); */
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.pdf {
  /* border-bottom: 2px solid #f0f0f0; */
}
</style>
